<script setup lang="ts">
interface IProps {
  zoomInLabel: string;
  zoomOutLabel: string;
}

interface IEmits {
  (e: "zoom-in"): void;
  (e: "zoom-out"): void;
}

const props = defineProps<IProps>();
defineEmits<IEmits>();
</script>

<template>
  <div class="map-zoom-controls">
    <button
      :aria-label="props.zoomInLabel"
      class="map-zoom-controls__button"
      type="button"
      @click="$emit('zoom-in')"
    >
      <svg
        aria-hidden="true"
        class="map-zoom-controls__icon"
        fill="none"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 5V19M5 12H19"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
      </svg>
    </button>
    <button
      :aria-label="props.zoomOutLabel"
      class="map-zoom-controls__button"
      type="button"
      @click="$emit('zoom-out')"
    >
      <svg
        aria-hidden="true"
        class="map-zoom-controls__icon"
        fill="none"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 12H19"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
      </svg>
    </button>
  </div>
</template>

<style scoped lang="scss">
.map-zoom-controls {
  @apply pointer-events-auto absolute right-6 top-6 flex w-11 flex-col items-center;

  filter: drop-shadow(0 4px 3px rgb(0 0 0 / 10%));

  &__button {
    @apply flex size-11 cursor-pointer items-center justify-center border border-neutral-light bg-white text-text-primary;

    &:first-child {
      @apply -mb-px rounded-t-lg;
    }

    &:last-child {
      @apply rounded-b-lg;
    }
  }

  &__icon {
    @apply size-6;
  }
}
</style>
